import { useContext } from "react"
import UtilitiesSurveyDataContext from '../context/UtilitiesSurveyDataProvider'

export default function useUtilitiesSurveyData() {
    return useContext(UtilitiesSurveyDataContext)
}
